const GENERATE_PERDIEM_PACKETS_FOR_JOB = '/api/e2e/perdiempacket/job/{jobId}';

export const GENERATE_PERDIEM_PACKETS_FOR_EMPLOYEES =
  '/api/e2e/perdiempacket/employees';

/**
 * Whole-job packet URL. WI 32018: `?bypassApproval=true` only on an explicit opt-in,
 * so the normal request is unchanged; the API refuses the bypass (403) without the feature.
 */
export function perDiemPacketJobUrl(
  jobId: string,
  bypassApproval: boolean
): string {
  const path = GENERATE_PERDIEM_PACKETS_FOR_JOB.replace(
    '{jobId}',
    String(jobId)
  );
  return bypassApproval ? `${path}?bypassApproval=true` : path;
}

/** Per-employee packet form body; WI 32018 adds `bypassApproval` only on opt-in. */
export function perDiemPacketEmployeesForm(
  employeeJobIds: string[],
  jobId: string,
  bypassApproval: boolean
): FormData {
  const formData = new FormData();
  formData.append('employeeJobIds', employeeJobIds.join(','));
  formData.append('jobId', String(jobId));
  if (bypassApproval) {
    formData.append('bypassApproval', 'true');
  }
  return formData;
}
